/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Tmsa_DescriptionInputs */



/**
* | output |
* | --- |
* | "Support and review against the Tanker Management and Self-Assessment programme." |
*
* @param {Service_Tmsa_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_tmsa_description = /** @type {((inputs?: Service_Tmsa_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Tmsa_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("对照油轮管理与自评估项目提供支持和审查。")
	return /** @type {LocalizedString} */ ("Support and review against the Tanker Management and Self-Assessment programme.")
});